import {useEffect, useRef} from 'react'
import {createPortal} from 'react-dom'

import './ReportDeleteConfirmation.scss'

const ReportDeleteConfirmation = ({
  cancelLabel,
  confirmLabel,
  deleting = false,
  onCancel,
  onConfirm,
  title,
}) => {
  const cancelButtonRef = useRef(null)

  useEffect(() => {
    cancelButtonRef.current?.focus()

    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && !deleting) {
        onCancel()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [deleting, onCancel])

  if (typeof document === 'undefined') {
    return null
  }

  return createPortal(
    <div
      className='report-delete-confirmation'
      role='dialog'
      aria-modal='true'
      aria-labelledby='report-delete-confirmation-title'
      onClick={() => !deleting && onCancel()}
    >
      <div
        className='report-delete-confirmation__panel'
        onClick={(event) => event.stopPropagation()}
      >
        <h3 id='report-delete-confirmation-title' className='report-delete-confirmation__title'>
          {title}
        </h3>
        <div className='report-delete-confirmation__actions'>
          <button type='button' className='btn btn-danger' disabled={deleting} onClick={onConfirm}>
            {confirmLabel}
          </button>
          <button
            ref={cancelButtonRef}
            type='button'
            className='btn btn-light'
            disabled={deleting}
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default ReportDeleteConfirmation
